import React from 'react';
import './BrandedCard.css';

interface BrandedCardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

/**
 * Branded card component for containing forms and content
 */
export const BrandedCard: React.FC<BrandedCardProps> = ({
  children,
  title,
  className = '',
}) => {
  return (
    <div className={`branded-card ${className}`}>
      {title && <h2 className="branded-card-title">{title}</h2>}
      <div className="branded-card-content">{children}</div>
    </div>
  );
};
